import { trigger, transition, animate, style } from '@angular/animations';

export const Init = trigger('init', [
    transition(':enter', [style({ transform: 'translateX(-100%)' }), animate('0.3s cubic-bezier(0.5, 0, 0.1, 1)', style({ transform: 'translateX(0%)' }))]),
    transition(':leave', [animate('0.3s cubic-bezier(0.5, 0, 0.1, 1)', style({ transform: 'translateX(-100%)' }))]),
]);
